<template>
    <header ref="siteHeader" :class="['header',{'header--not-top': isNotTop}]">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                    <a href="/" class="header__logo logo" aria-label="Security Watchdog Logo">
                        <slot name="site-logo"></slot>
                    </a>
                </div>
                <div class="col-auto order-xxl-last">
                    <div class="button-list">
                        <button @click="goToCart" class="svg-button svg-button--cart" title="Go to cart" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8H99.1C92.5 13 74.4 0 53.9 0H16zm90.1 64H539.5L497.6 231.8C494 246 481.2 256 466.5 256H145.4L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"/></svg>
                            <span v-if="this.cartItems > 0" class="cart-items">{{ this.cartItems }}</span>
                        </button>
                        <search-modal-button 
                            :initialItems="[
                                'Industry sectors',
                                'Reference checks',
                                'Criminal background checks',
                                'Employment risk consultancy services',
                                'Buy Screening Online',
                                'Pay per candidate screening',
                                'Low risk screening',
                                'Medium risk screening',
                                'High risk screening',
                                'BPSS screening',
                                'Basic criminal record checks for individuals',
                                'Social media checks',
                                'Build your own screen package',
                                'Help Hub'
                            ]"
                        />
                        <div v-if="buttons" class="header__button-list button-list">
                            <a v-for="button of buttons" :key="button.id" :href="button.url" :target="button.target" class="button button--primary">
                                {{ button.name }}
                            </a>
                        </div>
                        <button title="Toggle Navigation" type="button" :class="['burger-button',{'burger-button--open': drawerOpen}]" @click.prevent="toggleDrawer()">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
                <div class="col-12 col-xxl-auto">
                    <div :class="['site-navigation',{'site-navigation--drawer-open': drawerOpen}]">
                        <nav class="site-navigation__top nav">
                            <ul>
                                <li v-for="item of navigationData" :key="item.id" :class="['nav__item',{'nav__item--has-dropdown': item.subItems && item.subItems.length}]">
                                    <a class="nav__link" :href="item.url" :target="item.target">
                                        <span>{{ item.name }}</span>
                                        <span v-if="item.subItems && item.subItems.length" class="dropdown-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z"/></svg>
                                        </span>
                                    </a>
                                    <ul v-if="item.subItems && item.subItems.length" class="nav__dropdown">
                                        <li v-for="subItem of item.subItems" :key="subItem.id" class="nav__item">
                                            <a class="nav__dropdown-link" :href="subItem.url" :target="subItem.target">
                                                <span>{{ subItem.name }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                        <div v-if="drawerReady" class="site-navigation__drawer" :style="{top: drawerPadding}">
                            <div class="mobile-navigation">
                                <div v-for="item of navigationData" :key="item.id" :class="['mobile-navigation__item']">
                                    <button v-if="item.subItems && item.subItems.length" @click="toggleSubMenu(item.id + 1)">
                                        {{ item.name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z"/></svg>
                                    </button>
                                    <a v-else :href="item.url" :target="item.target">
                                        {{ item.name }}
                                    </a>
                                    <ul v-if="item.subItems && item.subItems.length" :class="['mobile-navigation__submenu',{'mobile-navigation__submenu--open': selectedSubMenus.find(menuId => menuId === item.id + 1 )}]">
                                        <li v-for="subItem of item.subItems" :key="subItem.id">
                                            <a :href="subItem.url" :target="subItem.target">
                                                <span>{{ subItem.name }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="buttons" class="button-list button-list--stacked">
                                <a v-for="button of buttons" :key="button.id" :href="button.url" :target="button.target" class="button button--primary">
                                  {{ button.name }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>

import SearchModalButton from '../components/SearchModalButton'
import _debounce from 'lodash/debounce';
import { toggleScroll } from '../../_helpers';

export default {
    name: 'site-header',
    data: () => ({
        isNotTop: false,
        drawerOpen: false,
        drawerReady: false,  
        drawerPadding: '0px',
        selectedSubMenus: [],
    }),
    props: {
        cartItems: {
            type: Number,
            default: 0
        }, 
        navigationData: {
            type: Array,
            required: true,
            default: () => []
        },
        cartUrl: {
            type: String,
            required: false,
            default: '/cart'
        },
        buttons: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    components: { SearchModalButton },
    methods: {
        checkTop() {
            this.isNotTop = (window.scrollY || window.pageYOffset) > 0;
        },
        getDrawerPadding() {
            this.drawerPadding = this.$refs.siteHeader.getBoundingClientRect().bottom + 'px';
        },
        setHeaderHeightCssVar() {
            document.documentElement.style.setProperty('--header-height', `${this.$refs.siteHeader.getBoundingClientRect().bottom + 'px'}`); 
        },
        toggleDrawer() {
            this.getDrawerPadding();
            this.drawerReady = !this.drawerReady;
            setTimeout(() => {  
                this.drawerOpen = !this.drawerOpen;
            }, 100);
            toggleScroll();
        },
        toggleSubMenu(id) {
            console.log(id);
            if(this.selectedSubMenus.includes(id)) {
                this.selectedSubMenus = this.selectedSubMenus.filter(menuId => menuId !== id);
            } else {
                this.selectedSubMenus.push(id);
            }
        },
        goToCart() {
            window.location.href = this.cartUrl;
        }
    },
    mounted() {
        this.checkTop();
        this.getDrawerPadding();
        this.setHeaderHeightCssVar();

        window.addEventListener('resize',() => {
            this.getDrawerPadding();
            this.setHeaderHeightCssVar();
        });
        window.addEventListener('orientationchange',() => {
            this.getDrawerPadding();
            this.setHeaderHeightCssVar();
        });
        window.addEventListener('scroll', _debounce(() => {
            this.checkTop();
            this.getDrawerPadding();
            this.setHeaderHeightCssVar();
        },1));
    }    
}
</script>